import * as React from "react";
import { Box } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { Switch } from "components";
import { PatientStateEnum } from "requests";
import { FormValues } from "../../../../duck";

const AllNormal: React.FC = () => {
  const { watch, reset } = useFormContext<FormValues>();
  const values = watch();

  const isChecked = Object.keys(values).every(
    key => (values as any)[key] === PatientStateEnum.Normal
  );

  return (
    <Box mb={6}>
      <Switch
        label="All normal"
        isChecked={isChecked}
        onChange={checked => {
          const newFieldState = checked ? PatientStateEnum.Normal : null;
          reset(
            Object.keys(values).reduce((acc, key) => {
              return { ...acc, [key]: newFieldState };
            }, {})
          );
        }}
      />
    </Box>
  );
};

export default AllNormal;
